import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-share-callback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: 'share-callback.component.html',
  styleUrl: 'share-callback.component.scss'
})
export class ShareCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  status: string | null = null;
  postUrl: string | null = null;
  errorMessage: string | null = null;
  btnPostDisabled: boolean = true;

  ngOnInit(): void {
    this.status = this.route.snapshot.queryParamMap.get('status');
    const rawPostUrl = this.route.snapshot.queryParamMap.get('post_url');
    const rawMessage = this.route.snapshot.queryParamMap.get('message');

    if (rawPostUrl && rawPostUrl.startsWith('http')) {
      this.postUrl = rawPostUrl;
    }

    if (rawMessage) {
      this.errorMessage = rawMessage;
    }

    // Esperar 2 segundos a que LinkedIn haya terminado de procesar la publicación.
    // Usamos un lambda para preservar el valor de `this`.
    setTimeout(() => {
      this.btnPostDisabled = false;
    }, 2000);
  }

  goToPost(): void {
    if (this.postUrl && !this.btnPostDisabled) {
      window.open(this.postUrl, '_blank');
    }
  }

  redirectBack(): void {
    const returnUrl = sessionStorage.getItem('callback_return_url');
    sessionStorage.removeItem('callback_return_url');

    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      this.router.navigate(['/']);
    }
  }
}
